import React from 'react';
import PropTypes from 'prop-types';
import css from './MoreOptions.scss';
import AccessibleDropdown from 'common/AccessibleDropdown';
import Icon from 'SF/MaterialIcon';

function MoreOptions(props) {

  const getOptions = () => {
    const options = [];

    if ( props.onStartMeeting && !props.inProgress && !props.groupSession ) options.push({
      key: "start-meeting",
      value: "start-meeting",
      text: <span><Icon icon='access_time' aria-hidden='true'/> Start Meeting</span>,
      className: "startMeeting",
    });

    if ( props.onRemoveFromQueue && !props.groupSession ) options.push({
      key: "student-left",
      value: "student-left",
      text: <span><Icon icon='subdirectory_arrow_left' aria-hidden='true'/> Student Left</span>,
      className: "studentLeft"
    });

    if ( props.onEditAppointment && !props.groupSession ) options.push({
      key: "edit-appointment",
      value: "edit-appointment",
      text: <span><Icon icon='edit' data-role='editAppointment' aria-hidden='true'/> Edit Appointment</span>,
      className: "editAppointment"
    });

    if ( props.onStartGroupSession && props.groupSession && !props.inProgress ) options.push({
      key: "start-group-session",
      value: "start-group-session",
      text: <span><Icon icon='access_time' aria-hidden='true'/> Start Group Session</span>,
      className: "startGroupSession"
    });

    if ( props.onEditGroupSession && props.groupSession ) options.push({
      key: "manage-participants",
      value: "manage-participants",
      text: <span><Icon icon='group' aria-hidden='true'/> Manage Participants</span>,
      className: "manageParticipants"
    });

    return options;
  };

  return (
    <AccessibleDropdown
      icon ='ellipsis horizontal'
      value={false}
      className={css['item-dropdown']}
      aria-label="Show more options"
      options={getOptions()}
      selectOnBlur={false}
      selectOnNavigation={false}
      openOnFocus={false}
      onChange={(e, { value }) => {
        // We defer to the onChange prop so the component also intercepts keyboard
        // events and not click events only
        switch ( value ) {
          case 'start-meeting':
            return props.onStartMeeting();
          case 'student-left':
            return props.onRemoveFromQueue();
          case 'edit-appointment':
            return props.onEditAppointment();
          case 'start-group-session':
            return props.onStartGroupSession();
          case 'manage-participants':
            return props.onEditGroupSession();
        }
      }}
    />
  );
}

MoreOptions.propTypes = {
  onRemoveFromQueue: PropTypes.func,
  onStartMeeting: PropTypes.func,
  onEditAppointment: PropTypes.func,
  onEditGroupSession: PropTypes.func,
  onStartGroupSession: PropTypes.func,
  inProgress: PropTypes.bool,
  groupSession: PropTypes.bool,
};

export default MoreOptions;
